const danhSachHoSoCongViec = (state) => state.danhSachHoSoCongViec;

const chiTietHoSoCongViec = (state) => state.chiTietHoSoCongViec

const doiTuongDuocTraLai = (state) => state.doiTuongDuocTraLai;

const treeDonVi = (state) => state.treeDonVi;

const treePhanXuLy = (state) => state.treePhanXuLy;

const lichSuThuHoi = (state) => state.lichSuThuHoi;

const lichSuPhanXuLy = (state) => state.lichSuPhanXuLy;

const lichSuTraLai = (state) => state.lichSuTraLai;

const lichSuCapNhatTinhHinhThucHien = (state) => state.lichSuCapNhatTinhHinhThucHien;

const luongXuLy = (state) => state.luongXuLy;

const countList = (state) => state.countList;

const treeDaPhanXuLy = (state) => state.treeDaPhanXuLy;

const treeDaPXLSearchData = (state) => state.treeDaPXLSearchData;

export default {
  treeDaPXLSearchData,
  countList,
  danhSachHoSoCongViec,
  chiTietHoSoCongViec,
  doiTuongDuocTraLai,
  treeDonVi,
  treePhanXuLy,
  lichSuThuHoi,
  lichSuPhanXuLy,
  lichSuTraLai,
  lichSuCapNhatTinhHinhThucHien,
  luongXuLy,
  treeDaPhanXuLy,
};
